
angular.module('v3sWbtPlayerApp').directive('v3sPulldown', ["$window", "v3sBrowserInfoService", function ($window, v3sBrowserInfoService) {
    return {
        restrict: 'A',
        link: function (scope, element, attributes, docCtrl, transclude) {
            if (attributes.v3sPulldown == "smart") {
                element.addClass("text-smart");

                var height, fullHeight;
                var body = $window.document.querySelector("body");

                var placeholder = angular.element(element[0].cloneNode(true));
                placeholder.addClass("placeholder");
                element.parent().prepend(placeholder);

                var calcHeight = function () {
                    fullHeight = placeholder[0].offsetHeight;
                }

                var updateHeight = function (evt) {
                    var scrollDistance;
                    if (!!evt && v3sBrowserInfoService.isIosAppViversa()) {//IPHONE
                        var v3sExercise = element.parent().find('v3s-exercise')[0];
                        scrollDistance = v3sExercise.offsetTop - v3sExercise.getBoundingClientRect().top;
                    } else {
                        scrollDistance = $window.pageYOffset;
                    }
                    height = fullHeight;
                    if (scrollDistance > 15) {
                        height = fullHeight - scrollDistance;

                        if (height < 30) {
                            height = 30;
                        }
                    }
                    element.css("max-height", height + "px");
                }

                angular.element($window).bind("resize", calcHeight);
                angular.element($window).bind("scroll", updateHeight);
                angular.element($window.document.querySelector("body")).bind("scroll", updateHeight);

                calcHeight();
                updateHeight();
            }
        }
    }
}]);